export default __webpack_public_path__ + "static/media/14.63171583.jpg";